import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CropService } from '../_services';
import * as CropActions from '../_actions/crop';

@Injectable({
  providedIn: 'root',
})
export class CropEffects {
  loadCrops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.loadCrops),
      mergeMap(({ fieldId, year }) =>
        this.cropService.getAndStoreCrops({ payload: { fieldId, year } }).pipe(
          map((crops) => CropActions.mergeCropsSuccess({ crops })),
          catchError((error) => of(CropActions.loadCropsFailure({ error })))
        )
      )
    )
  );

  mergeCrops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.mergeCrops),
      mergeMap((action) =>
        this.cropService.mergeCrops(action).pipe(
          map((crops) => CropActions.mergeCropsSuccess({ crops })),
          catchError((error) => of(CropActions.mergeCropsFailure({ error })))
        )
      )
    )
  );

  addCrop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.addCrop),
      mergeMap(({ crop }) =>
        this.cropService.saveCrop(crop).pipe(
          map((savedCrop) => CropActions.addCropSuccess({ crop: savedCrop })),
          catchError((error) => of(CropActions.addCropFailure({ error })))
        )
      )
    )
  );

  updateCrop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.updateCrop),
      mergeMap(({ crop }) =>
        this.cropService.saveCrop(crop).pipe(
          map((updatedCrop) => CropActions.updateCropSuccess({ crop: updatedCrop })),
          catchError((error) => of(CropActions.updateCropFailure({ error })))
        )
      )
    )
  );

  deleteCrop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.deleteCrop),
      mergeMap(({ crop }) =>
        this.cropService.deleteCrop(crop).pipe(
          map(() => CropActions.deleteCropSuccess({ id: crop.id })),
          catchError((error) => of(CropActions.deleteCropFailure({ error })))
        )
      )
    )
  );

  deleteMultiYearCrop$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CropActions.deleteMultiYearCrop),
      mergeMap(({ crop }) =>
        this.cropService.deleteMultiYearCrop(crop).pipe(
          map(() => CropActions.deleteCropSuccess({ id: crop.id })),
          catchError((error) => of(CropActions.deleteCropFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private cropService: CropService
  ) {}
}
